import { render, staticRenderFns } from "./xtNotice.vue?vue&type=template&id=35c09af6&"
import script from "./xtNotice.vue?vue&type=script&lang=js&"
export * from "./xtNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports